import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Avatar from 'shopper/components/Avatar';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { toStoreImageAltText } from 'lib/image';

const StoreName = ({ className, storeDomain, storeImage, storeName }) => (
  <div className={twJoin('flex items-center gap-x-2 md:gap-x-3', className)}>
    <div className="flex items-center gap-x-1 md:gap-x-2">
      <Avatar
        description={toStoreImageAltText(storeName)}
        icon="store"
        size="size5"
        src={storeImage}
      />
      <Text
        className="text-neutral-low-400 dark:text-neutral-high-200"
        size="size1"
        bold
      >
        {storeName}
      </Text>
    </div>
    {storeDomain && (
      <>
        <Icon name="verified-color" size="size3" />
        <Text
          className="text-neutral-low-400 dark:text-neutral-high-400"
          size="size2"
        >
          {storeDomain}
        </Text>
      </>
    )}
  </div>
);

StoreName.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  storeDomain: PropTypes.string,
  storeImage: PropTypes.string,
  storeName: PropTypes.string.isRequired,
};

export default StoreName;
